/**
 * Vega-Like tools add support for transformation, parameters, and value selection in the dashboard schemas.
 * It's not Vega, it is Vega-Like
 */

import {VegaLikeSchemaRoot } from "./VegaLikeToolsTypes";

import React from "react";
import { Dropdown, DropdownButton, ButtonToolbar, ButtonGroup, ToggleButton, Form } from "react-bootstrap";



/**
 * This function will parse the params section and return a React component that can be used to render the controls
 * to set the parameters. 
 * 
 * @param root 
 */
export function parseVegaLikeBindings(root: VegaLikeSchemaRoot, memory: any, needUpdate: () => void) {

    const bindMemory = memory.__bind__;
    const globobj = memory.__global__;
    const params = root.params || [];
    const bindings = [];
    let idx = 0;

    for (const param of params) {
        const key = "param-" + param.name + "-" + idx++;
        const currentValue = bindMemory[param.name] ?? globobj[param.name];

        if ("bind" in param && param.bind && typeof param.bind === "object" && typeof param.bind.input === "string") {
            const label = param.bind.name || param.name;

            if ((param.bind.input === "select" || param.bind.input === "radio") && param.bind.options?.length > 0) {
                const bind = param.bind;
                const labels = param.bind.options.map((o, i) => ({ value: o, label: typeof bind.labels?.[i] === "string" ? bind.labels[i] : String(o) }));

                if (Array.isArray(bind.options) && bind.options.length > 0) {

                    if (param.bind.input === "select") {

                        bindings.push(
                            <DropdownButton
                                as={ButtonGroup}
                                key={key}
                                id={"button-" + param.name}
                                onSelect={(e) => {
                                    bindMemory[param.name] = bind.options[e];
                                    if (currentValue !== bindMemory[param.name]) {
                                        needUpdate();
                                    }
                                }}
                                variant="secondary"
                                size="sm"
                                title={label}
                            >
                                {labels.map((o, i) => (
                                    <Dropdown.Item key={"select-" + o.value} eventKey={i}>
                                        {o.label}
                                    </Dropdown.Item>))
                                }
                            </DropdownButton>
                        );

                    } else if (param.bind.input === "radio") {

                        bindings.push(
                            <ButtonToolbar key={key}>
                                <ButtonGroup id={"button-" + param.name} size="sm">
                                    {labels.map((o, i) => (
                                        <ToggleButton key={"radio-" + o.value} id={"radio-" + o.value}
                                            type="radio"
                                            checked={currentValue === o.value}
                                            value={i}
                                            variant="secondary"
                                            size="sm"
                                            onClick={() => {
                                                bindMemory[param.name] = bind.options[i];
                                                if (currentValue !== bindMemory[param.name]) {
                                                    needUpdate();
                                                }
                                            }}
                                        >
                                            {o.label}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </ButtonToolbar>
                        );
                    }
                }
            } else if (param.bind.input === "range" && typeof param.bind.min === "number" && typeof param.bind.max === "number") {

                const bind = param.bind;
                bindings.push(
                    <Form key={key}>
                        <Form.Label>{label}</Form.Label>
                        <Form.Range 
                            min={bind.min} max={bind.max} value={currentValue}
                            onChange={(e) => {
                                bindMemory[param.name] = Number(e.target.value);
                                if (currentValue !== bindMemory[param.name]) {
                                    needUpdate();
                                }
                            }}
                        />
                    </Form>
                );

            } else if (param.bind.input === "checkbox") {

                bindings.push(
                    <Form key={key}>
                        <Form.Check 
                            type="switch"
                            checked={!!currentValue}
                            onChange={(e) => {
                                bindMemory[param.name] = e.target.checked;
                                if (currentValue !== bindMemory[param.name]) {
                                    needUpdate();
                                }
                            }}
                            label={label}
                        />
                    </Form>
                );

            }
        }
    }
    return bindings.length > 0 ? <div style={{position: "absolute", padding: "4px", zIndex: "1"}}>{bindings}</div> : null;
}




